// @ts-nocheck TODO

import {html} from "lit";
import {customElement, property} from "lit/decorators.js";
import moment from "moment";
import {styleMap} from "lit/directives/style-map.js";
import {MobxLitElement} from "@adobe/lit-mobx";
import {annotationHeaderStyles} from "./AnnotationHeader.styles.js";

@customElement("pn-annotation-header")
export class AnnotationHeader extends MobxLitElement {
	@property() annotation = {
		created_dt: null
	};
	@property() topic = {
		color: "",
		label: ""
	};
	@property({type: String})  sortBy = "";
	// ..rest?

	static styles = [annotationHeaderStyles];

	getTimestamp() {
		let timestamp = null;
		if (this.sortBy === "date") {
			const createdDt = moment(this.annotation.created_dt);
			timestamp = createdDt.format("YYYY.MM.DD - h:mma");
		}

		if (!timestamp)
			return null;

		return html`
			<span class="annotation-timestamp">${timestamp}</span>
		`;
	}

	render() {
		if ((this.sortBy === "topic") || !this.topic)
			return null;

		return html`
			<div class="annotation-header">
				<span
					class="annotation-topic"
					lang=""
					style=${styleMap({color: "#" + this.topic.color})}
				>
					${this.topic.label}
				</span>
				${this.getTimestamp()}
			</div>
		`;
	}
};

declare global {
	interface HTMLElementTagNameMap {
		"pn-annotation-header": AnnotationHeader;
	}
}
